import React, { useEffect, useState } from 'react';
import { focusMessageBox } from '../../../../AlmeUtilities/dom-utils';
import AlmeLiveChatSessionTimeoutPopup from './AlmeLiveChatSessionTimeoutPopup';
import * as Loaders from '@alme/storage-ts/CookieLoader';
import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import { gettopdomain } from '../../../../../utils/UrlUtils';
const storageLoader = new Loaders.CookieLoader('almeSession');
storageLoader.cookieOptions = { domain: gettopdomain() };
const cookieSessionLoader = new CookieAlmeSessionDataLoader(storageLoader);
const sessionDataLoader = cookieSessionLoader;
export function isValidLiveChatCheckUserStatusResponse(response) {
    return response.extensionData.MessageOrigin === "Operator-CheckUserStatus";
}
export function isLiveChatUserCheckStatusResponse(response) {
    return !!(response.extensionData.MessageSource === "LiveChat"
        && response.responseActions
        && response.responseActions.some(x => x.Name === "CheckUserStatus"));
}
function addUserCheckStatusResponse(almeState, setAlmeAppState, response) {
    var _a;
    let sessionId;
    try {
        sessionId = (_a = sessionDataLoader.GetAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.sessionId;
    }
    catch (ex) {
        console.log(ex);
    }
    const item = almeState.history.find(h => h.responseRevision === response.responseRevision);
    if (item) {
        item.fromHistory = true;
        setAlmeAppState(Object.assign(Object.assign({}, almeState), { history: [...almeState.history], customerCheckStatusMessage: { responseRevision: response.responseRevision, timeStamp: Date.now(), sessionId: sessionId } }));
    }
}
function removeUserCheckStatusResponse(almeState, setAlmeAppState) {
    setAlmeAppState(Object.assign(Object.assign({}, almeState), { customerCheckStatusMessage: undefined }));
}
function getUserCheckStatusTimestamp(almeState, responseRevision) {
    return almeState.customerCheckStatusMessage && almeState.customerCheckStatusMessage.responseRevision === responseRevision ?
        almeState.customerCheckStatusMessage.timeStamp : 0;
}
const AlmeLiveChatCheckUserStatusResponse = (props) => {
    const timeStamp = props.response.fromHistory ? getUserCheckStatusTimestamp(props.almeState, props.response.responseRevision) : 0;
    const timeDiff = timeStamp !== 0 ? Math.floor((Date.now() - timeStamp) / 1000) : timeStamp;
    const [showDialog, setShowDialog] = useState(() => ((!props.response.fromHistory) ||
        (props.response.fromHistory && timeStamp !== 0 && timeDiff < props.appConfig.liveChatOperatorResponse.userCheckStatus.timeoutInSec)));
    useEffect(() => {
        if (!props.response.fromHistory && showDialog) {
            addUserCheckStatusResponse(props.almeState, props.setAlmeAppState, props.response);
        }
    });
    if (!showDialog) {
        return null;
    }
    const closeDialog = () => {
        setShowDialog(false);
        removeUserCheckStatusResponse(props.almeState, props.setAlmeAppState);
        focusMessageBox();
    };
    const onEndChat = () => {
        props.onEndChat("User");
        closeDialog();
    };
    const onTimeout = () => {
        props.onEndChat("System");
        closeDialog();
    };
    const onContinueChat = () => {
        props.onContinueChat("User");
        closeDialog();
    };
    return (React.createElement(AlmeLiveChatSessionTimeoutPopup, { interval: 1000, timeoutInSec: props.appConfig.liveChatOperatorResponse.userCheckStatus.timeoutInSec - timeDiff, headerText: props.appConfig.liveChatOperatorResponse.userCheckStatus.dialog.headerText, bodyText: props.appConfig.liveChatOperatorResponse.userCheckStatus.dialog.bodyText, yesButtonText: props.appConfig.liveChatOperatorResponse.userCheckStatus.dialog.buttons.acceptButtonText, noButtonText: props.appConfig.liveChatOperatorResponse.userCheckStatus.dialog.buttons.declineButtonText, onYesClick: onContinueChat, onNoClick: onEndChat, onCloseClick: onContinueChat, onTimeout: onTimeout }));
};
export default AlmeLiveChatCheckUserStatusResponse;
